import { Stack, Typography } from '@mui/material'

import { PartialLoad } from './PartialLoad'

import type { BulkLoadPartial } from '../../../../../types'
import { useTexts } from './hooks/useTexts'

interface Props {
  loads: BulkLoadPartial[]
  onDeleteLoad: (name: string) => void
  onAddLoad: (name: string) => void
  ordersCount: number
  addableLoads: Set<string>
  maxLoadsForOrder: number
  disabled?: boolean
}

export function PartialList(props: Props) {
  const { loads, onDeleteLoad, onAddLoad, ordersCount, addableLoads, maxLoadsForOrder, disabled } =
    props
  const texts = useTexts()

  if (loads.length === 0) return null

  return (
    <Stack spacing={2}>
      <Typography variant="body2">{texts.title}</Typography>
      {loads.map(load => {
        return (
          <PartialLoad
            key={load.name}
            load={load}
            onDeleteLoad={() => onDeleteLoad(load.name)}
            onAddLoad={onAddLoad}
            ordersCount={ordersCount}
            maxLoadsForOrder={maxLoadsForOrder}
            addable={addableLoads.has(load.name)}
            disabled={disabled}
          />
        )
      })}
    </Stack>
  )
}
